// src/components/Dashboard/AgentDashboard/Inbox.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Inbox.css';

const Inbox = ({ userId, openConversationId, forceOpen }) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path, { state: { userId } });
  };

  return (
    <div className="agent-inbox">
      <div className="inbox-card">
        <h3 className="card-title">Inbox</h3>

        <div className="button-stack">
          <button onClick={() => handleNavigate('/agent/chats')}>Chats</button>
          <button onClick={() => handleNavigate('/agent/report')}>Agent Reporting</button>
          <button onClick={() => handleNavigate('/agent/vsnworld')}>VSN World</button>
        </div>
      </div>
    </div>
  );
};

export default Inbox;



























